import { AmOrPm, TimeClockFormat, TimeIn12HourClock, TimeIn24HourClock, TimeSeries } from './types';

export const getDefaultTimeValue = (time: TimeIn12HourClock | TimeIn24HourClock | undefined) =>
  time ? [time] : undefined;

export const getFormattedTime = (timeSeries: TimeSeries, format: TimeClockFormat) => {
  const { timeIn12HourClockWithoutAmPm, timeIn24HourClock, amOrPm } = timeSeries;
  const timeIn12HourClock = `${timeIn12HourClockWithoutAmPm} ${amOrPm}`;

  return format === '24-hour' ? timeIn24HourClock : timeIn12HourClock; // value is formatted in the same clock format as the input
};

/**
 * Generates list of time by x increment
 * @param {number} increment - in minutes
 * @returns
 */
export const generateTimeSeries = (increment: number): TimeSeries[] => {
  const times = [];
  const amPmArray = ['AM', 'PM'];

  let startHourInMinute = 0;
  const endHourInMinute = 1440;

  for (let i = 0; startHourInMinute < 24 * 60; i++) {
    if (startHourInMinute > endHourInMinute) break;

    const hours = Math.floor(startHourInMinute / 60); // hours in 24-hour clock format
    const minutes = startHourInMinute % 60; // minutes of hour in 0-59 format

    const amOrPm = amPmArray[Math.floor(hours / 12)] as AmOrPm;
    const formattedMinutes = `0${minutes}`.slice(-2); // last two digits. If minutes is single digit, add 0 in front.

    const hoursIn24HourClock = `0${hours % 24}`.slice(-2); // last two digits. If hours is single digit, add 0 in front.
    const hoursIn12HourClock = `0${hours % 12}`.slice(-2).replace('00', '12');

    const timeIn24HourClock = `${hoursIn24HourClock}:${formattedMinutes}`;
    const timeIn12HourClockWithoutAmPm = `${hoursIn12HourClock}:${formattedMinutes}`;

    times[i] = { timeIn12HourClockWithoutAmPm, timeIn24HourClock, amOrPm };

    startHourInMinute += increment;
  }

  return times;
};
